export enum SessionStatus {
  ALL = 'all',
  ACTIVE = 'active',
  PAUSED = 'paused',
  PINNED = 'pinned',
  COMPLETED = 'completed',
  COMPLETED_WITH_FAILURES = 'completed_with_failures',
  FAILED = 'failed',
  UPLOADED = 'uploaded',
  CANCELLED = 'cancelled'
}

export enum ApiSessionStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
  COMPLETED = 'completed',
  COMPLETED_WITH_FAILURES = 'completed_with_failures',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired'
}
